import styled from 'styled-components'
import Image from 'common/image'
import { useTranslation } from 'react-i18next'
import HKJCLogo from 'assets/HKJCLogo.svg'
import HKJCPriority from 'assets/HKJCPriority.svg'
import ButtonMenu from 'assets/button-menu.png'
import { adobeInteractionEvent } from 'utils/adobewa'

const HeaderContainer = styled.div`
    width: 100%;
    height: 110px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding: 0px 24px;
    background-color: white;
`

const LeftHeaderSection = styled.div`
    display: flex;
    flex-direction: row;
    margin-right: 60px;
`

const VerticalDivider = styled.div`
    width: 1px;
    margin: 2px 20px;
    background-color: #000;
`

const RightHeaderSection = styled.div`
    display: flex;
    flex-direction: row;
`

const MenuContainer = styled.div`
    cursor: pointer;
`

interface Props {
    setIsDrawerOpen: () => void
}
const Header: React.FC<Props> = ({ setIsDrawerOpen }) => {
    const { i18n } = useTranslation()
    const locale = i18n.language

    const openOfficialSite = () => {
        adobeInteractionEvent({
            lang: locale,
            eventID: 'prioritysite_click_Header_HKJC-Link',
        })

        if (locale === 'zh') {
            window.open('https://www.hkjc.com/zh-hk/index', '_blank')
        } else {
            window.open('https://www.hkjc.com/en-us/index', '_blank')
        }
    }

    return (
        <HeaderContainer>
            <LeftHeaderSection>
                <MenuContainer onClick={() => setIsDrawerOpen()}>
                    <Image
                        src={ButtonMenu}
                        width={22}
                        height={22}
                        alt="HKJC Logo"
                    />
                </MenuContainer>
            </LeftHeaderSection>
            <RightHeaderSection>
                <Image
                    src={HKJCLogo}
                    width={120}
                    height={48}
                    alt="HKJC Logo"
                    onClick={() => openOfficialSite()}
                />
                <VerticalDivider />
                <Image
                    src={HKJCPriority}
                    width={100}
                    height={50}
                    alt="HKJC Logo"
                />
            </RightHeaderSection>
        </HeaderContainer>
    )
}

export default Header
